const initialState = {
  skip_intro: true
}


export default (state = initialState, action) => {
  switch (action.type) {
    case 'QUICK_CREATE_LIST_RENDER':
      return {
        ...state,
        list_render: false
      }
    default:
      return state
  }
}
